import _ from "lodash";
// utils/geolocation.js
let cachedCoordinates = null;

export const getCoordinates = (): Promise<{ latitude; longitude }> => {
  return new Promise((resolve, reject) => {
    // Return cached coordinates if available
    if (cachedCoordinates) {
      resolve(cachedCoordinates);
      return;
    }

    if (!navigator.geolocation) {
      reject(new Error("Geolocation not supported"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        cachedCoordinates = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        resolve(cachedCoordinates);
      },

      (error) => {
        console.error("Geolocation error:", error);
        cachedCoordinates = {
          latitude: 0,
          longitude: 0,
        };
        reject(error);
      },
      { timeout: 10000 },
    );
  });
};

const THROTTLE_DELAY = 60 * 1000;

// Throttling function that ensures API calls are limited to once per delay period
function throttling(func, delay) {
  let lastExecutedTime = 0;

  return async function (...args) {
    const currentTime = Date.now();
    if (currentTime - lastExecutedTime >= delay) {
      lastExecutedTime = currentTime;
      //@ts-ignore
      return await func.apply(this, args); // Execute and return the result
    } else {
      const cachedIP = localStorage.getItem("ip");
      if (cachedIP && cachedIP !== "") {
        return cachedIP;
      }
      return undefined;
    }
  };
}

// Singleton throttled function to ensure shared state
const throttledFetchIP = throttling(async function () {
  const res = await fetch("https://api.ipify.org/?format=json");
  const final = await res.json();
  localStorage.setItem("ip", final.ip);
  return final.ip; // Return the IP directly
}, THROTTLE_DELAY);

export const getIP = async () => {
  const ip = await throttledFetchIP(); // Call the throttled function
  return ip; // Return the IP or undefined if throttled
};

// export const getIP = async () => {
//   try {
//     const res = await fetch("https://api.ipify.org/?format=json");
//     const final = await res.json();
//     return final.ip;
//   } catch (e) {
//     console.log(e["message"]);
//   }
// };
